<template>
  <div class="hand-writing">
    <div ref="wrap">
      <template v-if="!view">
        <canvas ref="container" class="hand-writing-canvas"></canvas>
      </template>
      <template v-else>
        <template v-if="issue.url">
          <div class="hand-writing-img">
            <img :src="previewUrl" alt="" />
          </div>
        </template>
      </template>
    </div>
    <div class="mt-2" v-if="!view">
      <van-button block size="small" plain type="primary" @click="clear">清空</van-button>
    </div>
  </div>
</template>

<script>
import Signature from 'signature_pad'
import { convertUrl } from 'dygc'

export default {
  name: 'HandWriting',
  changeExpr: 'changeExpr',
  data() {
    return {
      changeExpr: false
    }
  },
  computed: {
    previewUrl() {
      if (this.issue.url) {
        return convertUrl(this.issue.url)
      } else {
        return ''
      }
    }
  },
  methods: {
    init() {
      if (this.view) return
      const clientWidth = this.$refs.wrap.clientWidth - 2
      this.$refs.container.width = clientWidth

      let el = this.$refs.container
      let signature = new Signature(el, {
        onEnd: () => {
          this.changeExpr = true
        }
      })
      // signature.addEventListener('endStroke', () => {
      //
      // })
      this.issue.setSignature(signature)
    },
    clear() {
      this.issue.signature.clear()
    }
  },
  mounted() {
    this.init()
  }
}
</script>
